import { apiClient } from './ApiClient';
import { API_ENDPOINTS, PRODUCT_PRICE_MAP } from '../../shared/constants';
import { ApiResponse, BalanceApiData } from '../../shared/types';
import { Balance } from '../../domain/entities/SaleTransaction';

export interface BalanceWithPrice extends Balance {
    basePrice: number | null;
}

export class BalanceApi {
    static async fetchByVehicleAndProduct(
        vehiclePlate: string,
        productId: number,
        token: string
    ): Promise<BalanceWithPrice | null> {
        const cleanPlate = vehiclePlate.replace(/[^A-Z0-9]/g, '').toUpperCase();

        try {
            const response = await apiClient.get<ApiResponse<BalanceApiData>>(
                API_ENDPOINTS.balance(cleanPlate, productId),
                token
            );

            if (!response.success || !response.data) {
                return null;
            }

            const balance: Balance = {
                value: response.data.saldo_veiculo.valor,
                liters: response.data.saldo_veiculo.litros,
            };

            let basePrice: number | null = null;
            const priceKey = PRODUCT_PRICE_MAP[productId];
            if (priceKey && response.data.valores_produtos_rede) {
                const priceValue = (response.data.valores_produtos_rede as any)[priceKey];
                if (priceValue) {
                    basePrice = parseFloat(priceValue);
                }
            }

            return {
                ...balance,
                basePrice,
            };
        } catch (error) {
            console.error('Error fetching balance:', error);
            return null;
        }
    }
}

